import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { DATE_PICKER_DEFAULT_SIZE } from './utils';

import styles from './DateTimeSelector.module.css';

export default function DateTimePickerWrapper({
  component,
  title,
  height = DATE_PICKER_DEFAULT_SIZE,
  width = DATE_PICKER_DEFAULT_SIZE,
  subtitle,
  extra,
}: {
  component: React.ReactNode;
  title: string;
  height?: string;
  width?: string;
  subtitle?: React.ReactNode;
  extra?: React.ReactNode;
}) {
  return (
    <Box className={styles.date_time_picker_wrapper}>
      <Typography>{title}</Typography>
      {subtitle}
      <Stack className={styles.componentWrapper} sx={{ height, width }}>
        {component}
      </Stack>
      {extra}
    </Box>
  );
}
